import { render, staticRenderFns } from "./WordCloudImage.vue?vue&type=template&id=56255706&scoped=true&"
import script from "./WordCloudImage.vue?vue&type=script&lang=ts&"
export * from "./WordCloudImage.vue?vue&type=script&lang=ts&"
import style0 from "./WordCloudImage.vue?vue&type=style&index=0&id=56255706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56255706",
  null
  
)

export default component.exports